import React, { useState, useEffect, useMemo } from 'react';
import createCar from '../../../api/cars/createCar';
import getFactoryList from '../../../api/cars/getFactoryList';
import { useNavigate } from 'react-router-dom';

import Button from '../../../components/Button/Button';
import Loader from '../../../components/Loader/Loader';
import alert from '../../../helpers/alert';
import getClients from '../../../api/clients/getClients';
import HookForm from '../../../components/HookForm/HookForm';
import Select from '../../../components/Select/Select';
import CarSellerForm from './components/CarSellerForm';
import RequisitesForm from './components/RequisitesForm';
import DocumentsForm from './components/DocumentsForm';
import CarBuyerForm from './components/BuyerForm';
import { createBuyer } from '../../../api/cars/createBuyer';
import { createSeller } from '../../../api/cars/createSeller';
import { uploadCarDocument } from '../../../api/cars/uploadCarDocument';
import {
  CAR_DOC_TYPE_PURCHASE_CONTRACT,
  CAR_DOC_TYPE_INSPECTION_ACT,
  CAR_DOC_TYPE_PHOTOS,
  CAR_DOCUMENT_TYPE_MAP,
} from '../../../constants/carDocumentTypes';
// constants
import { CAR_ORIGIN_TYPES, CAR_ORIGIN_LABELS, PURCHASE_PROCESS_TYPES, USED_CAR_FACTORY_ID } from '../../../constants/carOrigin';
import sortFactoryList from '../../../utils/sortFactoryList';
import { allowedOriginOptions, tenant } from '../../../brand/tenant';
import { buildCarInfoInputs } from './carInfoInputs';
import ConsignmentCreate from './Consignment/ConsignmentCreate';
import getContainers from '../../../api/cars/getContainers';
import dayjs from 'dayjs';

const formStyles = {
  dealInfo: { display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr 1fr 1fr', alignItems: 'flex-end' },
  completeSet: { display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr' },
  other: { display: 'grid', gap: '20px', gridTemplateColumns: '1fr' },
};

const steps = [
  { key: 'car', label: 'ÐÐ°Ð½Ð½ÑÐµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ' },
  { key: 'seller', label: 'ÐÐ°Ð½Ð½ÑÐµ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°' },
  { key: 'buyer', label: 'ÐÐ°Ð½Ð½ÑÐµ Ð¿Ð¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ' },
  { key: 'requisites', label: 'Ð ÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ' },
  { key: 'documents', label: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ' },
];

const CarCreate = ({ mode }) => {
  // mode: 'new' â ÑÐ¾ÑÐ¼Ð° Ð½Ð¾Ð²ÑÑ Ð°Ð²ÑÐ¾ (ÑÐ¾Ð»ÑÐºÐ¾ Ð·Ð°Ð²Ð¾Ð´ÑÐºÐ¸Ðµ/Ð²Ð²ÐµÐ·ÑÐ½Ð½ÑÐµ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ),
  //       'used' â ÑÐ¾ÑÐ¼Ð° Ð±/Ñ Ð°Ð²ÑÐ¾ (ÑÐ¾Ð»ÑÐºÐ¾ 4 ÑÐ¸Ð¿Ð° Ð²ÑÐºÑÐ¿Ð°),
  //       undefined â ÑÑÐ°ÑÐ¾Ðµ Ð¿Ð¾Ð²ÐµÐ´ÐµÐ½Ð¸Ðµ (Ð²ÑÐµ ÑÐ¸Ð¿Ñ Ð² Ð¾Ð´Ð½Ð¾Ð¼ ÑÐ¿Ð¸ÑÐºÐµ).
  // Ð£ Ð±ÑÐ¾ÐºÐµÑÐ° ÑÐ¾Ð»ÑÐºÐ¾ Ñ ÐÐ£-Ð°Ð²ÑÐ¾ (JetQ) Ð»ÑÐ±Ð°Ñ ÑÐ¾ÑÐ¼Ð° ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ â ÐÐ£: Ð½Ð° Ð¾Ð±ÑÑÑ
  // /cars/create Ð²ÐµÐ´ÑÑ ÐºÐ½Ð¾Ð¿ÐºÐ° Â«ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÑÂ» Ð¸Ð· Ð¾Ð±ÑÐµÐ³Ð¾ ÑÐ¿Ð¸ÑÐºÐ°, Ð¸ Ð±ÐµÐ·
  // ÑÑÐ¾Ð³Ð¾ ÑÐ°Ð¼ Ð²ÑÐ¿Ð»ÑÐ²Ð°Ð»Ð¸ Ð½Ð¾Ð²ÑÐµ Ð¸ Ð·Ð°Ð²Ð¾Ð´ÑÐºÐ¸Ðµ Ð²Ð°ÑÐ¸Ð°Ð½ÑÑ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ.
  const effectiveMode = tenant?.usedCarsOnly ? 'used' : mode;
  const isUsedMode = effectiveMode === 'used';
  const isNewMode = effectiveMode === 'new';
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [carOrigin, setCarOrigin] = useState('');
  const [carData, setCarData] = useState({});
  const [sellerData, setSellerData] = useState(null);
  const [buyerData, setBuyerData] = useState(null);
  const [requisitesData, setRequisitesData] = useState(null);
  const [documentsData, setDocumentsData] = useState(null);
  const [contractData, setContractData] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [watchValues, setWatchValues] = useState({});
  const [file, setFile] = React.useState({});
  const [carId, setCarId] = useState(null);
  const [factoryList, setFactoryList] = useState([]);
  const [factoryId, setFactoryId] = useState(null);
  const [loadingFactoryList, setLoadingFactoryList] = useState(false);

  const [completeSet, setCompleteSet] = useState([
    { type: 'date', value: undefined, label: 'ÐÐ°ÑÐ° Ð¿ÑÐ¸Ð±ÑÑÐ¸Ñ Ð² Ð´Ð¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ', placeholder: 'Ð´Ð´-Ð¼Ð¼-Ð³Ð³Ð³Ð³' },
    {
      type: 'input',
      value: undefined,
      label: 'Ð¡ÐºÐ¸Ð´ÐºÐ° Ð´Ð¸Ð»ÐµÑÑÐºÐ¾Ð³Ð¾ ÑÐµÐ½ÑÑÐ°',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÑÐºÐ¸Ð´ÐºÑ Ð² Ð¿ÑÐ¾ÑÐµÐ½ÑÐ°Ñ',
      inputType: 'number',
    },
  ]);

  const [other, setOther] = useState([
    {
      type: 'select',
      value: undefined,
      label: 'ÐÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½ÑÐ¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      options: [
        { value: 1, label: 'ÐÐ°ÑÑÑÐ¶Ð°Ð½ Ð¨Ð°Ð³Ð°Ð±ÑÑÐ´Ð¸Ð½Ð¾Ð²' },
        { value: 2, label: 'ÐÐ°ÑÑÑÐ¶Ð°Ð½ Ð¨Ð°Ð³Ð°Ð±ÑÑÐ´Ð¸Ð½Ð¾Ð²' },
      ],
    },
  ]);
  const [containerId, setContainerId] = useState(null);

  const loadFactoryList = async () => {
    setLoadingFactoryList(true);
    try {
      const response = await getFactoryList();
      if (response?.data?.data) {
        setFactoryList(sortFactoryList(response.data.data));
      }
    } catch (error) {
      console.error('ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÐ¿Ð¸ÑÐºÐ° Ð·Ð°Ð²Ð¾Ð´Ð¾Ð²:', error);
      alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¿Ð¸ÑÐ¾Ðº Ð·Ð°Ð²Ð¾Ð´Ð¾Ð²');
    } finally {
      setLoadingFactoryList(false);
    }
  };

  const originOptions = useMemo(() => {
    // ÐÐµ-Ð·Ð°Ð²Ð¾Ð´ÑÐºÐ¸Ðµ ÑÐ¸Ð¿Ñ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ. Ð ÑÐµÐ¶Ð¸Ð¼Ðµ Â«ÐÐ£ Ð°Ð²ÑÐ¾Â» Ð¾ÑÑÐ°Ð²Ð»ÑÐµÐ¼ ÑÐ¾Ð»ÑÐºÐ¾ Ð²ÑÐºÑÐ¿Ð½ÑÐµ
    // (ÐÑÐºÑÐ¿ Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ° / Ð·Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ð³Ð¾ / Ð¼ÐµÐ½Ð° / Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ðµ), Ð² ÑÐµÐ¶Ð¸Ð¼Ðµ Â«ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾Â» â
    // ÑÐ¾Ð»ÑÐºÐ¾ Ð½Ðµ-Ð²ÑÐºÑÐ¿Ð½ÑÐµ (Ð½Ð°Ð¿Ñ. Â«ÐÐ¾Ð²Ð¾Ðµ Ð°Ð²ÑÐ¾, Ð²Ð²ÐµÐ·ÑÐ½Ð½Ð¾ÐµÂ»). ÐÐµÐ· ÑÐµÐ¶Ð¸Ð¼Ð° â Ð²ÑÐµ, ÐºÐ°Ðº ÑÐ°Ð½ÑÑÐµ.
    const baseOptions = Object.keys(CAR_ORIGIN_TYPES)
      .filter((key) => CAR_ORIGIN_TYPES[key] !== CAR_ORIGIN_TYPES.NEW_KZ)
      .filter((key) => {
        const isPurchase = PURCHASE_PROCESS_TYPES.includes(CAR_ORIGIN_TYPES[key]);
        if (isUsedMode) return isPurchase;
        if (isNewMode) return !isPurchase;
        return true;
      })
      .map((key) => ({
        value: CAR_ORIGIN_TYPES[key],
        label: CAR_ORIGIN_LABELS[CAR_ORIGIN_TYPES[key]],
      }));

    // Ð ÑÐµÐ¶Ð¸Ð¼Ðµ Â«ÐÐ£ Ð°Ð²ÑÐ¾Â» Ð·Ð°Ð²Ð¾Ð´ÑÐºÐ¸Ðµ (Ð½Ð¾Ð²ÑÐµ) Ð²Ð°ÑÐ¸Ð°Ð½ÑÑ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð²Ð¾Ð²ÑÐµ.
    if (isUsedMode) {
      // Ð£ Ð±ÑÐ¾ÐºÐµÑÐ° ÑÐ¾ ÑÐ²Ð¾Ð¸Ð¼ ÑÐ¿Ð¸ÑÐºÐ¾Ð¼ (JetQ â ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ) Ð¾ÑÑÐ°ÑÑÑÑ Ð»Ð¸ÑÑ Ð¾Ð½Ð¸.
      return allowedOriginOptions(baseOptions);
    }

    if (factoryList.length > 0) {
      const factoryOptions = factoryList
        // ÐÐ°Ð²Ð¾Ð´ Ð±/Ñ-Ð°Ð²ÑÐ¾ Ð½Ðµ Ð¼ÐµÑÑÐ¾ Ð² ÑÐ¿Ð¸ÑÐºÐµ Ð½Ð¾Ð²ÑÑ.
        .filter((factory) => factory.id !== USED_CAR_FACTORY_ID)
        .map((factory) => ({
          value: `factory_${factory.id}`,
          label: 'ÐÐ¾Ð²Ð¾Ðµ Ð°Ð²ÑÐ¾, ' + factory.name,
          factoryId: factory.id,
        }));
      return [...factoryOptions, ...baseOptions];
    } else {
      return [
        {
          value: CAR_ORIGIN_TYPES.NEW_KZ,
          label: CAR_ORIGIN_LABELS[CAR_ORIGIN_TYPES.NEW_KZ],
        },
        ...baseOptions,
      ];
    }
  }, [factoryList, isUsedMode, isNewMode]);

  const resolveContainerId = async ({ markOption, modelOption }) => {
    if (!markOption?.label || !modelOption?.label) {
      setContainerId(null);
      return;
    }

    try {
      const query = `${markOption.label} ${modelOption.label}`;
      const res = await getContainers({ markAndModel: query, page: 1 });
      const container = res?.data?.containers?.[0];
      setContainerId(container?.id ?? null);
    } catch (e) {
      console.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð¸Ñ containerId Ð¿Ð¾ Ð¼Ð°ÑÐºÐµ/Ð¼Ð¾Ð´ÐµÐ»Ð¸', e);
      setContainerId(null);
    }
  };

  // ÐÐ¾Ð»Ðµ Â«ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸ÐµÂ» â ÐµÐ´Ð¸Ð½ÑÑÐ²ÐµÐ½Ð½Ð¾Ðµ, ÑÑÐ¾ ÑÐ°Ð·Ð»Ð¸ÑÐ°ÐµÑÑÑ Ð¼ÐµÐ¶Ð´Ñ ÑÐºÑÐ°Ð½Ð°Ð¼Ð¸:
  // ÑÐ¿Ð¸ÑÐ¾Ðº Ð¾Ð¿ÑÐ¸Ð¹ Ð·Ð°Ð²Ð¸ÑÐ¸Ñ Ð¾Ñ ÑÐµÐ¶Ð¸Ð¼Ð° (Ð½Ð¾Ð²ÑÐµ / Ð±/Ñ). ÐÑÑÐ°Ð»ÑÐ½ÑÐµ ÑÐ°ÑÐ°ÐºÑÐµÑÐ¸ÑÑÐ¸ÐºÐ¸ Ð¾Ð±ÑÐ¸Ðµ
  // Ð¸ Ð¶Ð¸Ð²ÑÑ Ð² buildCarInfoInputs.
  const originInput = {
    component: Select,
    name: 'origin',
    label: 'ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ',
    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ¸Ð¿ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ',
    options: originOptions,
    onChangeCustom: (selectedOption) => {
      const newValue = selectedOption?.value;
      const prevOrigin = carOrigin;

      if (newValue !== prevOrigin && newValue) {
        if (typeof newValue === 'string' && newValue.startsWith('factory_')) {
          const selectedFactoryId = selectedOption.factoryId;
          setCarOrigin(CAR_ORIGIN_TYPES.NEW_KZ);
          setFactoryId(selectedFactoryId);
        } else {
          setCarOrigin(newValue);
          setFactoryId(null);
        }
        setCarData((prev) => ({ ...prev, origin: selectedOption }));

        setCurrentStep(0);
        setSellerData(null);
        setBuyerData(null);
        setRequisitesData(null);
        setDocumentsData(null);
        setContractData(null);
      }
    },
    rules: { required: true },
    defaultValue: carData?.origin,
  };

  const carInfo = [
    originInput,
    ...buildCarInfoInputs({
      carData,
      onMarkChange: () => setContainerId(null),
      onModelChange: (modelOption, markOption) => resolveContainerId({ markOption, modelOption }),
      getContainerId: () => containerId,
    }),
  ];

  useEffect(() => {
    getClients({ roleId: 2 }).then((res) => {
      const managers = res.data.users.map((item) => {
        return { value: item.id, label: item.name + ' ' + item.surname };
      });
      setOther([
        {
          type: 'select',
          value: undefined,
          label: 'ÐÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½ÑÐ¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ',
          placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
          options: managers,
        },
      ]);
    });
    loadFactoryList();
  }, []);

  const validateForm = (docsData = documentsData) => {
    if (PURCHASE_PROCESS_TYPES.includes(carOrigin)) {
      if (!sellerData) {
        alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð¿Ð¾Ð»Ð½Ð¸ÑÑ Ð´Ð°Ð½Ð½ÑÐµ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°');
        return false;
      }
      if (!buyerData) {
        alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð¿Ð¾Ð»Ð½Ð¸ÑÑ Ð´Ð°Ð½Ð½ÑÐµ Ð¿Ð¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ');
        return false;
      }
      if (!requisitesData) {
        alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð¿Ð¾Ð»Ð½Ð¸ÑÑ ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ');
        return false;
      }
      if (!docsData) {
        alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð²ÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ');
        return false;
      }
    }

    return true;
  };

  const handleSellerCreated = (sellerFormData) => {
    setSellerData(sellerFormData);
    console.log('Seller data saved:', sellerFormData);
    setCurrentStep(currentStep + 1);
  };

  const handleBuyerSubmit = (data) => {
    setBuyerData(data);
    console.log('Buyer data saved:', data);
    setCurrentStep(currentStep + 1);
  };

  const handleRequisitesSubmit = (data) => {
    setRequisitesData(data);
    console.log('Requisites data saved:', data);
    setCurrentStep(currentStep + 1);
  };

  const handleDocumentsSubmit = (data) => {
    setDocumentsData(data);
    console.log('Documents data saved:', data);
    createNewCar(data);
  };

  const getCarDataForContract = () => {
    const fieldByName = (name) => carInfo.find((f) => f?.name === name);

    return {
      make: fieldByName('mark')?.value?.label || 'ÐÐµ ÑÐºÐ°Ð·Ð°Ð½Ð°',
      model: fieldByName('model')?.value?.label || 'ÐÐµ ÑÐºÐ°Ð·Ð°Ð½Ð°',
      year: fieldByName('issueYear')?.value || 'ÐÐµ ÑÐºÐ°Ð·Ð°Ð½',
      vin: fieldByName('vin')?.value || 'ÐÐµ ÑÐºÐ°Ð·Ð°Ð½',
      color: fieldByName('color')?.value?.label || 'ÐÐµ ÑÐºÐ°Ð·Ð°Ð½',
      engineVolume: fieldByName('engine_volume')?.value || 'ÐÐµ ÑÐºÐ°Ð·Ð°Ð½',
      power: fieldByName('power')?.value || 'ÐÐµ ÑÐºÐ°Ð·Ð°Ð½Ð°',
    };
  };

  const shouldShowPurchaseProcess = () => {
    return PURCHASE_PROCESS_TYPES.includes(carOrigin);
  };

  const showStepper = PURCHASE_PROCESS_TYPES.includes(carOrigin);

  const isStepCompleted = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return carOrigin && carInfo.some((field) => field.value);
      case 1:
        return sellerData;
      case 2:
        return buyerData;
      case 3:
        return requisitesData;
      case 4:
        return documentsData;
      default:
        return false;
    }
  };

  // Ð ÐµÐ½Ð´ÐµÑ stepper
  const renderStepper = () => (
    <div style={{ display: 'flex', alignItems: 'center', margin: '0 20px' }}>
      {steps.map((step, idx) => {
        const isCompleted = isStepCompleted(idx);
        const isCurrent = idx === currentStep;

        return (
          <React.Fragment key={step.key}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minWidth: 120,
              }}
            >
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  background: isCompleted ? 'var(--brand-primary)' : isCurrent ? 'var(--brand-primary)' : 'var(--brand-row)',
                  color: isCompleted || isCurrent ? '#fff' : 'var(--brand-primary)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  fontSize: 16,
                  marginBottom: 4,
                }}
              >
                {isCompleted ? 'â' : idx + 1}
              </div>
              <span
                style={{
                  fontSize: 13,
                  color: 'var(--brand-primary)',
                  textAlign: 'center',
                }}
              >
                {step.label}
              </span>
            </div>
            {idx < steps.length - 1 && (
              <div
                style={{
                  flex: 1,
                  height: 2,
                  background: 'var(--brand-primary)',
                  margin: '0 8px',
                  marginTop: -10,
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );

  const handleCarInfoSubmit = (values) => {
    setCarData(values);
    // setCarInfo((prev) => prev.map((item) => ({ ...item, value: values[item.name] })));
    if (!values?.vin || values?.vin?.trim()?.length != 17) {
      alert.error('ÐÐ»Ð¸Ð½Ð° VIN Ð´Ð¾Ð»Ð¶Ð½Ð° Ð±ÑÑÑ 17 ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð²');
      return false;
    }

    if (!values?.issueYear || values?.issueYear > new Date().getFullYear() || values?.issueYear < 1900) {
      alert.error('ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð³Ð¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ° Ð°Ð²ÑÐ¾');
      return false;
    }

    if (!values?.mark?.value || !values?.model?.value) {
      alert.error('ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¼Ð°ÑÐºÑ Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ');
      return false;
    }

    if (!containerId) {
      alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ Ð¿Ð¾ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð¼Ð°ÑÐºÐµ/Ð¼Ð¾Ð´ÐµÐ»Ð¸');
      return false;
    }

    if (!carOrigin) {
      alert.error('ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ');
      return false;
    }
    setCurrentStep(currentStep + 1);
  };

  const validateAndCreateCar = async (values, onlyCreate) => {
    console.log('Car info submit:', values);
    if (!values?.vin || values?.vin?.trim()?.length != 17) {
      alert.error('ÐÐ»Ð¸Ð½Ð° VIN Ð´Ð¾Ð»Ð¶Ð½Ð° Ð±ÑÑÑ 17 ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð²');
      return false;
    }

    if (!values?.issueYear || values?.issueYear > new Date().getFullYear() || values?.issueYear < 1900) {
      alert.error('ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð³Ð¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ° Ð°Ð²ÑÐ¾');
      return false;
    }

    if (!carOrigin) {
      alert.error('ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ');
      return false;
    }

    if (carOrigin === CAR_ORIGIN_TYPES.NEW_KZ && !factoryId) {
      alert.error('ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð·Ð°Ð²Ð¾Ð´');
      return false;
    }

    if (!values?.mark?.value || !values?.model?.value) {
      alert.error('ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¼Ð°ÑÐºÑ Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ');
      return false;
    }

    if (!containerId) {
      alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ Ð¿Ð¾ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð¼Ð°ÑÐºÐµ/Ð¼Ð¾Ð´ÐµÐ»Ð¸');
      return false;
    }

    const originValue = values?.origin?.value;
    const isUsedFactory =
      typeof originValue === 'string' && originValue.startsWith('factory_')
        ? values?.isUsedFactory || factoryId === USED_CAR_FACTORY_ID
        : false;
    const isCarUsed =
      typeof originValue === 'string' && originValue.startsWith('factory_')
        ? isUsedFactory
        : PURCHASE_PROCESS_TYPES?.includes(originValue);

    const finalOrigin =
      typeof originValue === 'string' && originValue.startsWith('factory_') ? CAR_ORIGIN_TYPES.NEW_KZ : originValue;

    const carPayload = {
      phid: 5,
      originCarId: finalOrigin,
      containerId,
      markId: values?.mark?.value,
      modelId: values?.model?.value,
      complectationId: values?.complectationId?.value,
      transmissionId: values?.transmissionId?.value,
      issueYear: values?.issueYear,
      vin: values?.vin?.trim(),
      color: values?.color?.value,
      price: parseInt(values?.price?.replace(/[^\d]/g, '')),
      engine_volume: values?.engine_volume,
      powerId: values?.power,
      wdId: values?.wdId?.value,
      cityId: values?.cityId?.value,
      dealerId: values?.dealerId?.value,
      mileage: values?.mileage ? parseInt(values?.mileage) : undefined,
      arrivalDate: values?.arrivalDate,
      saleForeDealer: values?.saleForeDealer,
      managerId: values?.managerId?.value,
      paid: 5124,
      paidTypeId: 1,
      countryId: 113,
      used: isCarUsed,
      ...(factoryId && { factoryId }),
    };
    console.log(carPayload);
    const data = new FormData();
    data.append('photo', file.photo);
    data.append('json', JSON.stringify(carPayload));

    const response = await createCar(data);

    if (onlyCreate) {
      alert.success('ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐ¾Ð·Ð´Ð°Ð½');
      setTimeout(() => {
        navigate('/cars');
      }, 1000);
    }

    return response;
  };

  const renderStepContent = () => {
    if (!showStepper) {
      return (
        <HookForm
          inputs={carInfo}
          title={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾Ð± Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ðµ'}
          grid={formStyles.dealInfo}
          handlerSetState={(values) => {
            console.log('update', values);
            setCarData(values);
          }}
          onSubmit={(values) => validateAndCreateCar(values, true)}
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        />
      );
    }
    switch (steps[currentStep].key) {
      case 'car':
        return (
          <HookForm
            inputs={carInfo}
            title={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾Ð± Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ðµ'}
            grid={formStyles.dealInfo}
            handlerSetState={setCarData}
            onSubmit={handleCarInfoSubmit}
            action={'ÐÐ°Ð»ÐµÐµ'}
          />
        );
      case 'seller':
        return (
          <CarSellerForm
            onSellerCreated={handleSellerCreated}
            carData={getCarDataForContract()}
            currentData={sellerData}
          />
        );
      case 'buyer':
        return (
          <CarBuyerForm onBuyerCreated={handleBuyerSubmit} carData={getCarDataForContract()} currentData={buyerData} />
        );
      case 'requisites':
        return <RequisitesForm onSubmit={handleRequisitesSubmit} currentData={requisitesData} />;
      case 'documents':
        return <DocumentsForm onSubmit={handleDocumentsSubmit} currentData={documentsData} />;
      default:
        return null;
    }
  };

  const renderStepButtons = () => {
    return (
      <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
        {currentStep > 0 && <Button text={'ÐÐ°Ð·Ð°Ð´'} onClick={() => setCurrentStep(currentStep - 1)} />}
      </div>
    );
  };

  const createNewCar = async (currentDocsData = documentsData) => {
    if (!validateForm(currentDocsData)) return;
    setLoading(true);
    console.log('ALL DATA', carData, sellerData, buyerData, requisitesData, documentsData);
    try {
      let carIdLocal = carId;

      if (!carId) {
        const response = await validateAndCreateCar(carData);

        if (!response) return;
        carIdLocal = response.data?.car?.id || response.data?.id;
        setCarId(carIdLocal);
      }

      if (shouldShowPurchaseProcess() && sellerData) {
        console.log('Ð¡Ð¾Ð·Ð´Ð°Ð½Ð¸Ðµ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°...');

        try {
          await createSeller({
            ...sellerData,
            id: 0,
            CarId: carIdLocal,
            DOCUMENT_GIVED_DATE: dayjs(sellerData?.DOCUMENT_GIVED_DATE).format('DD.MM.YYYY'),
            bankAccount: requisitesData?.bankAccount,
            bankName: requisitesData?.bankName,
            bankBic: requisitesData?.bankBic,
          });
        } catch (error) {
          console.error('ÐÑÐ¸Ð±ÐºÐ° ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°:', error);
          alert.error(error.message || 'ÐÑÐ¸Ð±ÐºÐ° ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°');
        }
      }

      if (shouldShowPurchaseProcess() && buyerData) {
        console.log('Ð¡Ð¾Ð·Ð´Ð°Ð½Ð¸Ðµ Ð¿Ð¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ...');
        try {
          await createBuyer({
            CarId: carIdLocal,
            JuridicalName: buyerData.JuridicalName,
            JuridicalDirectorName: buyerData.JuridicalDirectorName,
            CompanyDetails: buyerData.CompanyDetails,
            ContractNumber: buyerData.ContractNumber,
            RepairWorkList: buyerData.RepairWorkList,
          });
        } catch (error) {
          console.error('ÐÑÐ¸Ð±ÐºÐ° ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ Ð¿Ð¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ:', error);
          alert.error(error.message || 'ÐÑÐ¸Ð±ÐºÐ° ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ Ð¿Ð¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ');
        }
      }

      const docsData = currentDocsData;
      if (docsData) {
        const docUploads = [
          {
            id: CAR_DOC_TYPE_PURCHASE_CONTRACT,
            file: docsData[CAR_DOC_TYPE_PURCHASE_CONTRACT] || docsData.purchaseContract,
          },
          {
            id: CAR_DOC_TYPE_INSPECTION_ACT,
            file: docsData[CAR_DOC_TYPE_INSPECTION_ACT] || docsData.inspectionAct,
          },
          { id: CAR_DOC_TYPE_PHOTOS, file: docsData[CAR_DOC_TYPE_PHOTOS] || docsData.photos },
        ];
        for (const { id, file } of docUploads) {
          if (file) {
            if (Array.isArray(file)) {
              for (const singleFile of file) {
                await uploadCarDocument({
                  file: singleFile,
                  carId: carIdLocal,
                  name: CAR_DOCUMENT_TYPE_MAP[id],
                  typeId: id,
                });
              }
            } else {
              await uploadCarDocument({
                file,
                carId: carIdLocal,
                name: CAR_DOCUMENT_TYPE_MAP[id],
                typeId: id,
              });
            }
          }
        }
      }

      alert.success('ÐÐ°Ð½Ð½ÑÐµ ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ñ');
      setTimeout(() => {
        navigate(`/cars/car/${carIdLocal}/main-data`);
      }, 1000);
    } catch (error) {
      console.error('ÐÑÐ¸Ð±ÐºÐ° ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ:', error);
      alert.error(error.message || 'ÐÑÐ¸Ð±ÐºÐ° ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ');
    } finally {
      setLoading(false);
    }
  };

  // ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ Ð¾ÑÐ¾ÑÐ¼Ð»ÑÐµÑÑÑ Ð½Ð° Ð¾Ð´Ð½Ð¾Ð¼ ÑÐºÑÐ°Ð½Ðµ, Ð±ÐµÐ· ÑÑÐµÐ¿Ð¿ÐµÑÐ°: ÑÐ°Ð¼ ÑÐ²Ð¾Ð¸ Ð±Ð»Ð¾ÐºÐ¸
  // (Ð¢Ð¡ + ÑÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑ, Ð¿ÑÐ¾Ð´Ð°Ð²ÐµÑ-ÐºÐ»Ð¸ÐµÐ½Ñ, ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ ÐÐ¦) Ð¸ ÑÐ²Ð¾Ñ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ðµ.
  if (carOrigin === CAR_ORIGIN_TYPES.CONSIGNMENT) {
    return (
      <div style={{ paddingBottom: '20px', marginTop: 20 }}>
        <ConsignmentCreate originInput={originInput} />
      </div>
    );
  }

  return (
    <>
      {loading && <Loader />}
      <div style={{ paddingBottom: '20px', marginTop: 20 }}>
        {/* <div className={styles.newClientDataPhoto}>
          <label>
            <input
              type="file"
              onChange={(event) => {
                setFile({ photo: event.target.files[0] });
              }}
            />
            <img alt="" />
            <p>ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¾ÑÐ¾ Ñ Ð¿Ðº</p>
            <span>ÐÐ·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ Ð² ÑÐ¾ÑÐ¼Ð°ÑÐµ PNG Ð¸Ð»Ð¸ JPEG Ð½Ðµ Ð±Ð¾Ð»ÐµÐµ 200 ÐÐ±</span>
          </label>
        </div> */}
        {showStepper && renderStepper()}
        {renderStepContent()}
        {renderStepButtons()}
      </div>
    </>
  );
};

export default CarCreate;
